import { Grid } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import React, { useEffect, useState } from "react";
import { ShowProps, useDataProvider } from "react-admin";
import { StudentResources } from "utils/tools";
import SplitPaymentTable from "./components/SplitPaymentTable";
import CcaSplitPaymentTable from "./components/CcaSplitPaymentTable";
import StudentSubsidyDisabledComponent from "./components/StudentSubsidyDisabledComponent";
import StudentSubsidyTable from "./components/StudentSubsidyTable";

const SplitPayment = (props: ShowProps) => {
  const provider = useDataProvider();
  const [school, setSchool] = useState<ISchool>();

  const { id } = props;
  const studentResources = StudentResources(Number(id));

  useEffect(() => {
    provider
      .getOne("schools", { id: Number(studentResources.schoolId) })
      .then(({ data }) => {
        setSchool(data as ISchool);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12}>
        <SplitPaymentTable
          {...props}
          useDifferentCcaSplitPayment={school?.useDifferentCcaSplitPayment}
        />
      </Grid>

      {school &&
        school.isCcaSettingEnable &&
        school.useDifferentCcaSplitPayment && (
          <Grid item xs={12}>
            <CcaSplitPaymentTable {...props} />
          </Grid>
        )}

      {school && school.isStudentSubsidyEnable ? (
        <Grid item xs={12}>
          <StudentSubsidyTable {...props} />
        </Grid>
      ) : (
        <Grid item xs={12}>
          <StudentSubsidyDisabledComponent
            schoolId={studentResources.schoolId}
          />
        </Grid>
      )}
    </SanitizedGrid>
  );
};

export default SplitPayment;
